import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ReportTemplate, TemplatesService, Pageable } from '@src/api/reports';
import { TableModule } from '@src/app/modules/table';
import { BaseTablePageComponent } from '@src/app/components';

import { TABLE_NAME } from './constants';
import { CreateFormComponent, EditFormComponent } from './components';
import { ReportTemplateUI } from './types';
import { catchError, lastValueFrom, of, throwError } from 'rxjs';

@Component({
  selector: 'app-reports-templates-table',
  standalone: true,
  imports: [TableModule, CreateFormComponent, EditFormComponent],
  templateUrl: './reports-templates.component.html',
  styleUrl: './reports-templates.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportsTemplatesComponent extends BaseTablePageComponent<
  ReportTemplateUI,
  ReportTemplateUI,
  CreateFormComponent,
  EditFormComponent,
  undefined,
  undefined,
  undefined,
  undefined
> {
  private readonly templatesService = inject(TemplatesService);

  @Input() selectedItem?: ReportTemplateUI;
  @Output() onSelectionChanged = new EventEmitter<ReportTemplateUI[]>();

  visible = true;

  constructor() {
    super({
      tableName: TABLE_NAME,
      dataKey: 'uuid',
      toolbarOptions: {
        visible: true,
        // buttonsLimit: 2, // TODO: разобраться - доп меню отображается по второму клику
        buttons: {
          create: 'reportsTemplatesCreate',
          edit: 'reportsTemplatesEdit',
        },
      },
      rowMenuOptions: {
        visible: false,
      },
      columnOptions: {
        sorting: true,
      },
      createDialogOptions: {
        header: 'Загрузка шаблона отчёта',
      },
      editDialogOptions: {
        header: 'Редактирование шаблона',
      },
      selecting: true,
      selectionMode: 'single',
      sortField: 'name',
      sortOrder: -1,
      columns: ['name', 'description', 'filename'],
      excludeColumns: ['contentType', 'uploadedAt', 'uploadedBy'],
    });
  }

  override getRequestObservable(pageable?: Pageable) {
    return this.templatesService.getTemplates(undefined, pageable);
  }

  override async onCreate() {
    if (!this.createData) return;

    const { file, description, name } = this.createData;
    if (!file) return;

    return await lastValueFrom(
      this.templatesService.uploadTemplate(file, description, name).pipe(
        catchError(err => {
          this.alertService.error(err.error.message, true);
          return throwError(() => new Error(err));
        }),
      ),
    );
  }

  override async rowEdit(item: ReportTemplate) {
    if (!this.editData?.uuid) return;

    return await lastValueFrom(
      of(item),
      // this.templatesService.uploadTemplate(this.editData.uuid, this.editData).pipe(
      //   catchError(err => {
      //     this.alertService.error(err.error.message, true);
      //     return throwError(() => new Error(err));
      //   }),
      // ),
    );
  }

  selectionChange(value: ReportTemplate[]) {
    this.selectedItem = value[0];
    this.onSelectionChanged.emit(value);
  }
}
